export default __webpack_public_path__ + "static/media/home-5-slider-graphic.c6d62007.png";